<template>
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.44819 14C9.44819 15.3333 8.11452 16 6.7812 16C5.44787 16 4.11421 15.3333 4.11421 14H9.44819ZM13.3945 1.41406C13.6548 1.15371 14.0775 1.15371 14.3378 1.41406C14.5981 1.67442 14.5982 2.09709 14.3378 2.35742L12.038 4.65625C12.0863 4.88001 12.1142 5.10622 12.1142 5.33301V10.667L13.4472 11.333V12.667H4.02827L1.13862 15.5566C0.878294 15.817 0.455617 15.8169 0.195262 15.5566C-0.0650873 15.2963 -0.0650873 14.8736 0.195262 14.6133L2.14155 12.667H2.14057L11.4814 3.3252V3.32617L13.3945 1.41406ZM6.7812 0C8.09998 0.000215087 8.44008 1.30505 8.44722 1.33301C9.17177 1.33301 9.95927 1.71206 10.6181 2.30371L0.255809 12.667H0.114207V11.333L1.44722 10.667V5.33301C1.44743 3.33324 3.44769 1.33325 5.11421 1.33301C5.12005 1.31003 5.45981 0.000198439 6.7812 0Z"
      fill="#A1A1AA"
    />
  </svg>
</template>

<script>
export default {
  name: 'NotificationDisabled',
  props: {
    color: {
      type: String,
      default: 'midnight',
    },
  },
}
</script>

<style lang="scss" scoped></style>
